export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-one-pill-solution-9be5f66b1694bb809b93ab4919583f59.jpg";